export default {"src":"/_next/static/media/laundry.ab7fab86.svg","height":40,"width":32,"blurWidth":0,"blurHeight":0};